import actions from 'netxcore@netx/core-app/actions';

import {
	datamanagerAuthorized,
	datamanagerEnabled,
} from '@netx/core-data-set/enablers';
import {notMobile, reviewEnabled} from '@netx/core/lib/netx-enablers.js';
import {bulkCartLoaderEnabled} from '@netx/core-upload/enablers';

import {extendBackboneActions} from '@netx/core/utils/extendBackboneActions';

import {icon} from '@fortawesome/fontawesome-svg-core';
import {
	faBell,
	faCaretLeft,
	faChartPie,
	faClipboardList,
	faCloud,
	faCogs,
	faExclamationTriangle,
	faFolder,
	faHammer,
	faHome,
	faInbox,
	faInboxIn,
	faPhone,
	faPowerOff,
	faQuestionCircle,
	faSearch,
	faSyncAlt,
	faTable,
	faUser,
} from '@fortawesome/pro-solid-svg-icons';

const iconOpts = {classes: ['fa-fw']};
const icons = {
	faBell: icon(faBell, iconOpts).html,
	faCaretLeft: icon(faCaretLeft, iconOpts).html,
	faChartPie: icon(faChartPie, iconOpts).html,
	faClipboardList: icon(faClipboardList, iconOpts).html,
	faCloud: icon(faCloud, iconOpts).html,
	faCogs: icon(faCogs, iconOpts).html,
	faExclamationTriangle: icon(faExclamationTriangle, iconOpts).html,
	faFolder: icon(faFolder, iconOpts).html,
	faHammer: icon(faHammer, iconOpts).html,
	faHome: icon(faHome, iconOpts).html,
	faInbox: icon(faInbox, iconOpts).html,
	faInboxIn: icon(faInboxIn, iconOpts).html,
	faPhone: icon(faPhone, iconOpts).html,
	faPowerOff: icon(faPowerOff, iconOpts).html,
	faQuestionCircle: icon(faQuestionCircle, iconOpts).html,
	faSearch: icon(faSearch, iconOpts).html,
	faSyncAlt: icon(faSyncAlt, iconOpts).html,
	faTable: icon(faTable, iconOpts).html,
	faUser: icon(faUser, iconOpts).html,
};

// Extend actions defined in core file
let newActions = extendBackboneActions(actions, [
	{
		event: 'app:contact',
		icon: icons.faPhone,
		label: i18n.t('i18n.contact'),
	},
	{
		event: 'app:help',
		icon: icons.faQuestionCircle,
	},
	{
		event: 'app:logout',
		icon: icons.faPowerOff,
		route: 'logout',
	},
	{
		event: 'app:reportProblem',
		icon: icons.faExclamationTriangle,
	},
]);

// New actions
newActions = newActions.concat([
	/** @action */
	{
		event: 'nx:system:autotasks',
		icon: icons.faSyncAlt,
		label: i18n.t('i18n.autoTasks'),
		route: 'system/autotasks',
	},
	/** @action */
	{
		event: 'nx:collections',
		icon: icons.faInbox,
		label: i18n.t('i18n.collections'),
	},
	/** @action */
	{
		event: 'nx:folders',
		label: i18n.t('i18n.categories'),
		icon: icons.faFolder,
	},
	/** @action */
	{
		event: 'nx:home',
		icon: icons.faHome,
		label: i18n.t('i18n.home'),
	},
	/** @action */
	{
		event: 'nx:notifications',
		label: i18n.t('i18n.notifications'),
		icon: icons.faBell,
	},
	/** @action */
	{
		event: 'nx:searches',
		label: i18n.t('i18n.searches'),
		icon: icons.faSearch,
	},
	/** @action */
	{
		event: 'nx:system',
		label: i18n.t('i18n.system'),
		icon: icons.faCogs,
		enableTest: notMobile,
	},
	{
		event: 'nx:tools',
		label: i18n.t('i18n.tools'),
		icons: icons.faHammer,
	},
	{
		event: 'app:upload',
		label: i18n.t('i18n.uploadAssets'),
		icon: icons.faCloud,
		userLevel: 3,
	},
	{
		event: 'app:upload:assets',
		label: i18n.t('i18n.upload'),
		icon: icons.faCloud,
		userLevel: 3,
		route: 'upload/status',
	},
	/** @action */
	{
		event: 'app:upload:attributeData',
		label: i18n.t('i18n.importAttributeData'),
		icon: icons.faArchive,
		userLevel: 4,
	},
	/** @action */
	{
		event: 'app:upload:bulkCartLoader',
		label: i18n.t('i18n.bulkCartLoader'),
		icon: icons.faInboxIn,
		enableTest: bulkCartLoaderEnabled,
		userLevel: 2,
	},
	// This is here because the dataSet controller comes too late
	{
		event: 'dataSet:dataSets',
		icon: icons.faTable,
		label: i18n.t('i18n.dataSets'),
		enableTest: [datamanagerAuthorized, datamanagerEnabled],
	},
	/** @action */
	{
		event: 'dataSet:dataSets:route',
		icon: icons.faTable,
		label: i18n.t('i18n.dataSets'),
		enableTest: [datamanagerAuthorized, datamanagerEnabled, notMobile],
		route: 'dataset/datasets',
	},
	/** @action */
	{
		event: 'projects:route',
		icon: icons.faClipboardList,
		label: i18n.t('i18n.reviews'),
		enableTest: reviewEnabled,
		route: 'projects',
		userLevel: 1,
	},
	/** @action */
	{
		event: 'stat:route',
		icon: icons.faChartPie,
		label: i18n.t('i18n.statistics'),
		enableTest: notMobile,
		route: 'stat',
		userLevel: 8,
	},
]);

export default newActions;
